import React from 'react';
import { faFileLines } from '@fortawesome/free-regular-svg-icons';
import { faBuilding } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './SpeakerLinkedSponsorIcon.module.scss';
import { SPONSOR_RELATION_ABSTRACT, SPONSOR_RELATION_ORGANIZATION } from '../../../../../../data/constants/speakers';

const ICONS = {
    [SPONSOR_RELATION_ABSTRACT]: faFileLines,
    [SPONSOR_RELATION_ORGANIZATION]: faBuilding,
};

function SpeakerLinkedSponsorIcon(props) {
    const { className = '', relation } = props,
        icon = ICONS[relation];

    if (!icon) return null;

    return <FontAwesomeIcon icon={icon} className={[styles.icon, className].join(' ')} />;
}

export default SpeakerLinkedSponsorIcon;
